import React, { Component } from "react";
import {Icon, Rate} from 'antd'



class FlyTerrainLocation extends Component {

    constructor(props) {
        super(props)
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }
    }
    render() {
        const ars = [];
        let svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
        console.log('############### this.props.svrlocation ****************')
        console.log(this.props.my_data_flyreview)
        const {offer} = this.props.my_data_flyreview
        let itn = offer.itineraries[0]
        let segStart = itn.segments[0] 
        let sum_org = segStart.departure.iataCode
        let n = itn.segments.length
        let segEnd = itn.segments[n-1]
        let sum_departure = segStart.departure.at

        let sum_arrival = segEnd.arrival.at
    let sum_dst = segEnd.arrival.iataCode
    let sum_stops = n -1
   
    //let sum_duration_dis = this.fltTime(sum_duration)
    //let sum_airlines = 'ZZ'
     let sum_airlines = segStart.carrierCode
    
        
        //console.log(this.props.svrlocation)






        return (

      
        
            <header className="svr-header2" style={{paddingBottom:"5px"}}>
              
                <p className="m-para-text-first" style={{paddingTop:"20px"}}>
                    <span> 
                        <text className="svr-hotel-name"  style={{fontSize:"1.5.em", paddingRight:"10px",color:"rgb(208,156,31)"}}>Airlines {sum_airlines}, {sum_org} to {sum_dst}</text>
        
                        <Icon  style={{ color:"rgb(215, 125, 10)" , fontSize:"20px" }} type="slack-square" theme="filled" />
                    </span>
                    
                    <span className="ter-l2 svr-hotel-location" style={{marginTop:"10px", marginBottom:"7px"}}>
                        <text style={{fontSize:"15px", color:"rgb(132, 115, 97)", fontWeight:"400", paddingRight:"15px"}}>
                        {sum_org}
                        </text>
                        <Icon  style={{ color: "rgb(7, 115, 29)", fontSize:"20px" }} type="environment" theme="filled" />
                        <text style={{fontSize:"16px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>Excellent2- Shown On Map</text> 
                    </span>
                        
                    <span style={{fontSize: "12px"}} style={{marginTop:"10px",display:"block", marginBottom:"7px"}} > 
                       
                        <text style={{fontSize:"12px", color:"rgb(129, 133, 142)",paddingRight:"10px", paddingLeft:"0px",fontWeight:"400"}}>232 reviews</text>
                        <Icon  style={{ color: '#eb2f96' }} type="car" theme="filled" />
                        <text style={{fontSize:"12px", color:"rgb(129, 133, 142)", paddingLeft:"10px",fontWeight:"420"}}>Hotels within 7 miles from Airport</text>
                    </span>
                    
                    <span style={{fontSize: "18px"}} > 
                        <Icon  style={{ color: '#eb2f96' }} type="dingtalk-square" theme="filled" />
                        <text style={{fontSize:"16px", color:"rgb(18, 85, 219)", paddingLeft:"10px",fontWeight:"420"}}>Hotels  Website</text>
                    </span>
                     
                    
                </p>

            </header>
        )
    }

}

export default FlyTerrainLocation;